export default "__VITE_ASSET__BaMT7sWT__"